//quantityProducts
function quantityProducts() {
    let $quantityArrowMinus = document.querySelectorAll('.quantity-arrow-minus');
    let $quantityArrowPlus = document.querySelectorAll('.quantity-arrow-plus');

    $quantityArrowMinus.forEach((element)=>{
        element.addEventListener('click',quantityMinus);
    });
    $quantityArrowPlus.forEach((element)=>{
        element.addEventListener('click',quantityPlus);
    });

    function quantityMinus(e) {
        e.preventDefault();
        let $quantityNum = this.nextElementSibling;
        console.log($quantityNum);
        if ($quantityNum.value > 1) {
            console.log($quantityNum + $quantityNum.value);
            $quantityNum.value -=  1;
        }
    }

    function quantityPlus(e) {
        e.preventDefault();
        let $quantityNum = this.previousElementSibling;
        $quantityNum.value = (Number($quantityNum.value) + 1);
    }
}
quantityProducts();